import React from 'react';
import PropTypes from 'prop-types';

import BannerSettingsPresenter from '../../../../../../presenters/BannerSettingsPresenter';

const BannerSetting = (props) => {
  const { bannerSetting, onEditBannerSetting } = props;

  const handleClick = () => onEditBannerSetting(bannerSetting);

  return (
    <React.Fragment>
      <tr>
        <td>{BannerSettingsPresenter.bannerTypeReadable(bannerSetting)}</td>
        <td>{BannerSettingsPresenter.title(bannerSetting)}</td>
        <td className="shortText">
          {BannerSettingsPresenter.text(bannerSetting)}
        </td>
        <td>
          {BannerSettingsPresenter.fontColor(bannerSetting)}
          <span
            className="color-circle"
            style={{
              backgroundColor: BannerSettingsPresenter.fontColor(bannerSetting),
            }}
          ></span>
        </td>
        <td>
          {BannerSettingsPresenter.backgroundColor(bannerSetting)}
          <span
            className="color-circle"
            style={{
              backgroundColor:
                BannerSettingsPresenter.backgroundColor(bannerSetting),
            }}
          ></span>
        </td>
        <td>
          {BannerSettingsPresenter.submitButtonColor(bannerSetting)}
          <span
            className="color-circle"
            style={{
              backgroundColor:
                BannerSettingsPresenter.submitButtonColor(bannerSetting),
            }}
          ></span>
        </td>
        <td>{BannerSettingsPresenter.submitButtonText(bannerSetting)}</td>
        <td>
          <div>
            <button className="action-button" onClick={handleClick}>
              Change
            </button>
          </div>
        </td>
      </tr>
    </React.Fragment>
  );
};

BannerSetting.propTypes = {
  bannerSetting: BannerSettingsPresenter.shape().isRequired,
  onEditBannerSetting: PropTypes.func.isRequired,
};

export default BannerSetting;
